module.exports = __webpack_public_path__ + "static-v-shop/1784033416981/img/logo_maestro.ced7dab5.png";